(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mc-announcement"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mc-announcement')) {
    customElements.define('mc-announcement', class extends HTMLElement {
      connectedCallback() {
        this.panels = Array.from(this.querySelectorAll('.mc-announcement__panel'));
        this.button = this.querySelector('.mc-announcement__accessible-control');
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.hover = window.matchMedia('(hover: hover)');
        this.index = 0;
        this.visible = true;
        this.onEnter = () => { this.hovered = this.hover.matches; };
        this.onLeave = () => { this.hovered = false; };
        this.onPause = () => {
          const paused = this.toggleAttribute('data-paused');
          const label = paused ? this.button.dataset.playLabel : this.button.dataset.pauseLabel;
          this.button.setAttribute('aria-label', label);
          this.button.textContent = label;
        };
        this.onMotion = () => { this.button.hidden = this.motion.matches; };
        this.addEventListener('mouseenter', this.onEnter);
        this.addEventListener('mouseleave', this.onLeave);
        this.button.addEventListener('click', this.onPause);
        this.motion.addEventListener('change', this.onMotion);
        this.resizeObserver = new ResizeObserver(() => {
          document.documentElement.style.setProperty('--announcement-bar-height', `${this.offsetHeight}px`);
        });
        this.resizeObserver.observe(this);
        this.visibilityObserver = new IntersectionObserver(entries => {
          this.visible = entries[0].isIntersecting;
        });
        this.visibilityObserver.observe(this);
        this.setAttribute('data-ready', '');
        this.onMotion();
        this.rotationTimer = window.setInterval(() => this.next(), 6500);
      }

      next() {
        if (this.motion.matches || this.hasAttribute('data-paused') || this.hovered || !this.visible || document.hidden) return;
        if (this.panels.some(panel => panel.contains(document.activeElement))) return;
        const previous = this.panels[this.index];
        const nextIndex = (this.index + 1) % this.panels.length;
        const upcoming = this.panels[nextIndex];
        previous.dataset.active = 'false';
        previous.setAttribute('aria-hidden', 'true');
        previous.setAttribute('tabindex', '-1');
        previous.inert = true;
        this.swapTimer = window.setTimeout(() => {
          upcoming.dataset.active = 'true';
          upcoming.setAttribute('aria-hidden', 'false');
          upcoming.removeAttribute('tabindex');
          upcoming.inert = false;
          this.index = nextIndex;
        }, 220);
      }

      disconnectedCallback() {
        window.clearInterval(this.rotationTimer);
        window.clearTimeout(this.swapTimer);
        this.removeEventListener('mouseenter', this.onEnter);
        this.removeEventListener('mouseleave', this.onLeave);
        this.button.removeEventListener('click', this.onPause);
        this.motion.removeEventListener('change', this.onMotion);
        this.resizeObserver.disconnect();
        this.visibilityObserver.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mc-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mc-hero-gif')) {
    customElements.define('mc-hero-gif', class extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('button');
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.userPaused = false;
        this.inView = true;
        this.update = () => {
          const paused = this.userPaused || this.motion.matches || !this.inView || document.hidden;
          this.toggleAttribute('data-paused', paused);
          this.button.toggleAttribute('data-paused', paused);
          this.button.setAttribute('aria-label', paused ? this.button.dataset.playLabel : this.button.dataset.pauseLabel);
          this.button.hidden = this.motion.matches;
        };
        this.onToggle = () => { this.userPaused = !this.userPaused; this.update(); };
        this.button.addEventListener('click', this.onToggle);
        this.motion.addEventListener('change', this.update);
        document.addEventListener('visibilitychange', this.update);
        this.visibility = new IntersectionObserver(entries => {
          this.inView = entries[0].isIntersecting;
          this.update();
        }, { threshold: 0.05 });
        this.visibility.observe(this);
        this.update();
      }
      disconnectedCallback() {
        this.button.removeEventListener('click', this.onToggle);
        this.motion.removeEventListener('change', this.update);
        document.removeEventListener('visibilitychange', this.update);
        this.visibility.disconnect();
      }
    });
  }
  if (!customElements.get('mc-hero-video')) {
    customElements.define('mc-hero-video', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.video = this.querySelector('video');
        this.button = this.querySelector('button');
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.desktop = window.matchMedia('(min-width: 768px)');
        this.userPaused = false;
        this.manualPlay = false;
        this.inView = true;
        this.onPlaying = () => {
          const reveal = () => {
            if (this.video.readyState >= 2 && !this.video.paused) this.setAttribute('data-video-ready', '');
          };
          if (this.video.requestVideoFrameCallback) this.video.requestVideoFrameCallback(reveal);
          else reveal();
          this.updateButton();
        };
        this.onPause = () => this.updateButton();
        this.onError = () => { this.removeAttribute('data-video-ready'); this.updateButton(); };
        this.onToggle = () => {
          if (this.video.paused) {
            this.userPaused = false;
            this.manualPlay = true;
            this.start();
          } else {
            this.userPaused = true;
            this.manualPlay = false;
            this.video.pause();
          }
        };
        this.onMotionChange = () => {
          this.manualPlay = false;
          if (this.motion.matches) {
            this.video.autoplay = false;
            this.video.pause();
            this.removeAttribute('data-video-ready');
          } else this.start();
        };
        this.onViewportChange = () => {
          this.removeAttribute('data-video-ready');
          this.start();
        };
        this.onVisibilityChange = () => {
          if (document.hidden) this.video.pause();
          else this.start();
        };
        this.video.addEventListener('playing', this.onPlaying);
        this.video.addEventListener('pause', this.onPause);
        this.video.addEventListener('error', this.onError);
        this.button.addEventListener('click', this.onToggle);
        this.motion.addEventListener('change', this.onMotionChange);
        this.desktop.addEventListener('change', this.onViewportChange);
        document.addEventListener('visibilitychange', this.onVisibilityChange);
        this.visibility = new IntersectionObserver(entries => {
          this.inView = entries[0].isIntersecting;
          if (this.inView) this.start();
          else this.video.pause();
        }, { threshold: 0.05 });
        this.visibility.observe(this);
        this.button.hidden = false;
        this.updateButton();
        if (this.video.readyState >= 2 && !this.video.paused) this.onPlaying();
        this.start();
      }
      updateButton() {
        const paused = this.video.paused;
        this.button.toggleAttribute('data-paused', paused);
        this.button.setAttribute('aria-label', paused ? this.button.dataset.playLabel : this.button.dataset.pauseLabel);
      }
      start() {
        if (document.hidden || !this.inView || this.userPaused) return;
        if (!this.manualPlay && (this.motion.matches || navigator.connection?.saveData)) return;
        const source = this.desktop.matches && this.dataset.desktopVideo ? this.dataset.desktopVideo : this.dataset.mobileVideo;
        if (!source) return;
        this.video.muted = true;
        this.video.preload = 'auto';
        this.video.autoplay = true;
        if (this.video.getAttribute('src') !== source) this.video.src = source;
        this.video.play().catch(() => this.updateButton());
      }
      disconnectedCallback() {
        this.video.pause();
        this.visibility?.disconnect();
        this.video.removeEventListener('playing', this.onPlaying);
        this.video.removeEventListener('pause', this.onPause);
        this.video.removeEventListener('error', this.onError);
        this.button.removeEventListener('click', this.onToggle);
        this.motion.removeEventListener('change', this.onMotionChange);
        this.desktop.removeEventListener('change', this.onViewportChange);
        document.removeEventListener('visibilitychange', this.onVisibilityChange);
        this.initialized = false;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mc-outfit-comparison"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('mc-look-compare')) {
  customElements.define('mc-look-compare', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const range = this.querySelector('input[type="range"]');
      const frame = this.querySelector('.mc-look__frame');
      const update = () => {
        frame.style.setProperty('--split', range.value + '%');
        frame.dataset.view = range.value === '0' ? 'after' : range.value === '100' ? 'before' : 'split';
      };
      range.addEventListener('input', update);
      update();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mc-pdp-reviews"] && !Shopify.designMode) return;
  try {
    

  if (!customElements.get('mc-preview-reviews')) {
    customElements.define('mc-preview-reviews', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.setupCarousel();
      }

      setupCarousel() {
        const grid = this.querySelector('[data-pr-grid]');
        const cards = Array.from(this.querySelectorAll('[data-pr-card]'));
        const previous = this.querySelector('[data-pr-prev]');
        const next = this.querySelector('[data-pr-next]');
        const controls = this.querySelector('[data-pr-controls]');
        if (!grid || !cards.length || !previous || !next) return;
        this.carouselEvents = new AbortController();
        const options = { signal:this.carouselEvents.signal };
        let active = 0;
        const targetFor = card => {
          const padding = parseFloat(getComputedStyle(grid).paddingLeft) || 0;
          const value = grid.scrollLeft + card.getBoundingClientRect().left - grid.getBoundingClientRect().left - padding;
          return Math.max(0,Math.min(grid.scrollWidth-grid.clientWidth,value));
        };
        const update = () => {
          const left = grid.scrollLeft;
          const maximum = grid.scrollWidth-grid.clientWidth;
          active = cards.reduce((best,card,index) => Math.abs(targetFor(card)-left) < Math.abs(targetFor(cards[best])-left)-1 ? index : best,0);
          previous.disabled = left <= 2;
          next.disabled = left >= maximum-2;

        };
        const go = index => grid.scrollTo({left:targetFor(cards[Math.max(0,Math.min(cards.length-1,index))]),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
        previous.addEventListener('click',()=>go(active-1),options);
        next.addEventListener('click',()=>go(active+1),options);
        grid.addEventListener('keydown',event=>{
          if (!['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
          event.preventDefault();
          go(event.key==='Home'?0:event.key==='End'?cards.length-1:active+(event.key==='ArrowRight'?1:-1));
        },options);
        grid.addEventListener('scroll',()=>{
          cancelAnimationFrame(this.carouselFrame);
          this.carouselFrame=requestAnimationFrame(update);
        },{...options,passive:true});
        this.carouselResize=new ResizeObserver(update);
        this.carouselResize.observe(grid);
        controls.hidden=false;
        update();
        try {
          const target=JSON.parse(sessionStorage.getItem('mc-review-preview-target')||'null');
          if (target && target.path===location.pathname && Date.now()-target.time<30000) {
            sessionStorage.removeItem('mc-review-preview-target');
            this.carouselRestore=setTimeout(()=>this.scrollIntoView({block:'start',behavior:'instant'}),250);
          }
        } catch {}
      }

      disconnectedCallback() {
        this.carouselEvents?.abort();
        this.carouselResize?.disconnect();
        cancelAnimationFrame(this.carouselFrame);
        clearTimeout(this.carouselRestore);
        this.ready = false;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mc-pdp-style"] && !Shopify.designMode) return;
  try {
    
(function(){
  function syncBundleGallery(widget){
    const data=document.querySelector('[data-mc-variant-media]');
    const bar=widget.querySelector('.kaching-bundles__bar--selected');
    const first=bar?.querySelector('select');
    const gallery=document.querySelector('.product-media');
    if(!data||!first||!gallery)return;
    const product=JSON.parse(data.textContent);
    const choices=new Map(Array.from(first.parentElement.querySelectorAll('select')).map(control=>[control.dataset.name||control.getAttribute('aria-label'),control.value]));
    const variant=product.variants.find(item=>item.options.every((value,index)=>choices.get(product.options[index])===value));
    if(!variant?.media)return;
    const slider=gallery.querySelector('[data-js-product-media-slider]');
    if(!slider)return;
    const slides=Array.from(slider.querySelectorAll('.js-product-gallery-slide[data-media-id]'));
    const index=slides.findIndex(slide=>slide.dataset.mediaId===String(variant.media));
    if(index<0)return;
    const active=slider.querySelector('.js-product-gallery-slide.swiper-slide-active');
    if(active?.dataset.mediaId!==String(variant.media)){
      if(slider.swiper&&!slider.swiper.destroyed){
        slider.swiper.slideTo(index);
        slider.swiper.updateAutoHeight(0);
      }else{
      const section=gallery.closest('[data-section-type="product"]');
      const original=document.querySelector('[data-js-product-json]');
      const originalProduct=original?JSON.parse(original.textContent):null;
      const fullVariant=originalProduct?.variants.find(item=>item.id===variant.id);
      if(section&&window.themeCore?.EventBus&&fullVariant){
        window.themeCore.EventBus.emit('pdp:section-'+section.dataset.sectionId+':change-variant',{variantId:variant.id,variant:{...fullVariant,featured_media:{id:variant.media}},product:originalProduct,firstInitialization:false});
      }else{
        gallery.querySelector('button[data-slide-index="'+index+'"]')?.click();
      }
      }
    }
    const url=new URL(location.href);
    if(url.searchParams.get('variant')!==String(variant.id)){
      url.searchParams.set('variant',variant.id);
      history.replaceState(history.state,'',url);
    }
  }
  function bindOpeningGallery(){
    const gallery=document.querySelector('.product-media');
    const data=document.querySelector('[data-mc-variant-media]');
    const slider=gallery?.querySelector('[data-js-product-media-slider]');
    if(!gallery||!data||!slider||slider.dataset.mcOpeningBound)return;
    slider.dataset.mcOpeningBound='true';
    const product=JSON.parse(data.textContent);
    const apply=id=>{
      if(!gallery.isConnected||!slider.swiper||slider.swiper.destroyed)return;
      const variant=product.variants.find(item=>String(item.id)===String(id));
      if(!variant?.media)return;
      const slides=Array.from(slider.querySelectorAll('.js-product-gallery-slide[data-media-id]'));
      const index=slides.findIndex(slide=>slide.dataset.mediaId===String(variant.media));
      if(index<0)return;
      slider.swiper.slideTo(index,0);
      slider.swiper.updateAutoHeight(0);
    };
    const initial=()=>apply(new URL(location.href).searchParams.get('variant')||product.selected);
    if(slider.swiper&&!slider.swiper.destroyed)initial();
    else{
      const observer=new MutationObserver(()=>{
        if(!slider.swiper||slider.swiper.destroyed)return;
        observer.disconnect();
        requestAnimationFrame(initial);
      });
      observer.observe(slider,{attributes:true,attributeFilter:['class'],childList:true});
    }
    const section=gallery.closest('[data-section-type="product"]');
    if(section&&window.themeCore?.EventBus){
      window.themeCore.EventBus.listen('pdp:section-'+section.dataset.sectionId+':change-variant',event=>requestAnimationFrame(()=>apply(event.variantId||event.variant?.id)));
    }
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',bindOpeningGallery,{once:true});
  else bindOpeningGallery();
  document.addEventListener('shopify:section:load',bindOpeningGallery);
  function schedule(widget){requestAnimationFrame(()=>requestAnimationFrame(()=>syncBundleGallery(widget)));}
  document.addEventListener('change',event=>{
    const widget=event.target.closest('.kaching-bundles');
    if(!widget||event.target.tagName!=='SELECT')return;
    const first=widget.querySelector('.kaching-bundles__bar--selected select');
    if(first?.parentElement.contains(event.target))schedule(widget);
  },true);
  document.addEventListener('click',event=>{
    const button=event.target.closest('[role="button"]');
    const widget=button?.closest('.kaching-bundles');
    if(widget)schedule(widget);
  },true);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mc-track"] && !Shopify.designMode) return;
  try {
    
function maisonCamilTracking(event) {
  const form = event.target.closest('[data-mc-tracking]');
  if (!form) return;
  event.preventDefault();
  const input = form.elements.namedItem('num');
  input.value = input.value.trim();
  if (!form.reportValidity()) return;
  window.open('https://t.17track.net/en#nums=' + encodeURIComponent(input.value), '_blank', 'noopener,noreferrer');
}
document.addEventListener('submit', maisonCamilTracking);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mc-welcome-popup"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mc-welcome-popup')) {
    customElements.define('mc-welcome-popup', class extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        if (!this.dialog || !this.dialog.showModal) return;
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        this.storageKey = 'maison-camil-welcome-until-v3';
        this.triggers = document.querySelectorAll('[data-mc-welcome-trigger]');
        this.triggers.forEach(button => {
          button.hidden = false;
          button.setAttribute('aria-controls', this.dialog.id);
          button.setAttribute('aria-haspopup', 'dialog');
          button.addEventListener('click', () => this.open(), options);
        });
        this.querySelectorAll('[data-mc-welcome-close]').forEach(button => button.addEventListener('click', () => this.dialog.close(), options));
        this.dialog.addEventListener('close', () => {
          document.documentElement.classList.remove('mc-welcome-is-open');
          if (!this.querySelector('[data-form-result="success"]')) this.remember(Number(this.dataset.dismissDays) || 7);
        }, options);
        this.dialog.addEventListener('click', event => {
          const box = this.dialog.getBoundingClientRect();
          if (event.target === this.dialog && (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom)) this.dialog.close();
        }, options);
        const result = this.querySelector('[data-form-result]');
        if (result) {
          if (result.dataset.formResult === 'success') this.remember(365);
          this.open();
          this.querySelector('[tabindex="-1"]')?.focus();
          return;
        }
        document.addEventListener('shopify:section:select', event => {
          if (event.detail.sectionId === this.dataset.sectionId) this.open();
        }, options);
        if (this.dataset.designMode === 'true' || this.dataset.subscribed === 'true' || !['index', 'product', 'collection'].includes(this.dataset.pageType) || this.isDismissed()) return;
        this.timer = setTimeout(() => this.tryOpen(), Math.max(1, Number(this.dataset.delay) || 3) * 1000);
      }
      isDismissed() {
        try { return Date.now() < Number(localStorage.getItem(this.storageKey) || sessionStorage.getItem(this.storageKey)); } catch { return false; }
      }
      remember(days) {
        const until = String(Date.now() + days * 86400000);
        try { localStorage.setItem(this.storageKey, until); } catch { try { sessionStorage.setItem(this.storageKey, until); } catch {} }
      }
      tryOpen() {
        if (!this.isConnected || this.isDismissed()) return;
        const cookieBanner = document.querySelector('#shopify-pc__banner');
        const cookieVisible = cookieBanner && cookieBanner.getBoundingClientRect().height > 0 && getComputedStyle(cookieBanner).visibility !== 'hidden';
        const otherModal = [...document.querySelectorAll('dialog[open], [aria-modal="true"]')].some(element => {
          const box = element.getBoundingClientRect();
          const style = getComputedStyle(element);
          return style.visibility !== 'hidden' && style.display !== 'none' && Number(style.opacity) > 0 && box.width > 0 && box.height > 0 && box.left < innerWidth && box.right > 0 && box.top < innerHeight && box.bottom > 0;
        });
        const busy = document.hidden || otherModal || document.activeElement?.matches('input, textarea, select, [contenteditable="true"]');
        if (cookieVisible || busy) { this.timer = setTimeout(() => this.tryOpen(), 1000); return; }
        this.open();
      }
      open() {
        clearTimeout(this.timer);
        if (this.dialog.open) return;
        this.dialog.showModal();
        document.documentElement.classList.add('mc-welcome-is-open');
        this.querySelector('.mc-welcome__title')?.focus({ preventScroll: true });
      }
      disconnectedCallback() {
        clearTimeout(this.timer);
        this.events?.abort();
        if (this.dialog?.open) document.documentElement.classList.remove('mc-welcome-is-open');
        this.triggers?.forEach(button => { button.hidden = true; });
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
